import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

interface EmployeeProtectedRouteProps {
  children: React.ReactNode;
}

const EmployeeProtectedRoute: React.FC<EmployeeProtectedRouteProps> = ({ children }) => {
  const { user, loading, isEmployee } = useAuth();

  // Return null while loading - GlobalLayout is already showing navbar/sidebar
  if (loading) {
    return null;
  }

  if (!user) {
    // Not logged in, redirect to sign-in page
    return <Navigate to="/sign-in" replace />;
  }

  if (!isEmployee) {
    // Logged in but not an employee, redirect to dashboard or unauthorized page
    return <Navigate to="/dashboard" replace />;
  }

  // User is logged in and is an employee, render the children
  return <>{children}</>;
};

export default EmployeeProtectedRoute;
